<div class="client-logo-section py-5">
    <div class="">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Prominent <span>Clients</span></h2>
            <div class="title-underline"></div>
        </div>
        <div class="logo-slider-container">
            <div class="logo-track">
                <!-- First Copy -->
                <div class="logo-slide" *ngFor="let logo of logos">
                    <img [src]="logo.src" [alt]="logo.alt" />
                </div>
                <!-- Second Copy for Seamless Loop -->
                <div class="logo-slide" *ngFor="let logo of logos">
                    <img [src]="logo.src" [alt]="logo.alt" />
                </div>
            </div>
        </div>
    </div>
</div>